import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Box,
  Card,
  CardContent,
  Divider,
  TextField,
  useMediaQuery,
  useTheme
} from '@mui/material';
import axios from "axios";
import utils from "../../utils";

const Notifiche = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const res = await axios.get(`/api/listatemplateemail`, {
        headers: utils.getAuthHeaders(),
      });
      const { success, error, emails } = res.data;
      if (success) {
        setNotifications(emails);
      } else {
        console.error(error);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const filteredNotifications = notifications.filter(notification =>
    notification.subject.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Container maxWidth="lg">
      <Box sx={{ my: 4 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 2
          }}
        >
          <Typography variant="h4" component="h1">
            Notifiche
          </Typography>
          {!isMobile && (
            <TextField
              label="Cerca per titolo"
              variant="outlined"
              size="small"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              sx={{ width: '300px' }}
            />
          )}
        </Box>

        <Typography variant="body1" paragraph sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
          Di seguito sono elencate tutte le notifiche che possono essere inviate ai clienti e agli operatori.
        </Typography>

        {isMobile && (
          <TextField
            fullWidth
            label="Cerca per titolo"
            variant="outlined"
            size="small"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{ mb: 0 }}
          />
        )}

        <Box sx={{ mt: 4 }}>
          {filteredNotifications.map((notification, index) => (
            <Card key={index} sx={{ mb: 2 }}>
              <CardContent>
                <Typography variant="h6" component="h2" gutterBottom>
                  <strong>{notification.subject}</strong>
                </Typography>
                <Typography variant="body1" paragraph>
                  {notification.message}
                </Typography>
                <Divider sx={{ my: 1 }} />
                <Typography variant="body2" color="textSecondary">
                  {notification.explanation}
                </Typography>
              </CardContent>
            </Card>
          ))}
        </Box>
      </Box>
    </Container>
  );
};

export default Notifiche;
